import dayjs from 'dayjs';

export default {
  // ======================= COMMON =========================
  GET_APP_MENU(state) {
    return state.appMenu;
  },
  GET_APPL_YMD(state) {
    return state.applYmd;
  },
  GET_REQUEST_HOUR(state) {
    return state.requestHour;
  },
  // 시작시간
  GET_REQ_S_HM(state) {
    return state.reqSHm !== ''
      ? `${state.reqSHm.substr(0, 2)}:${state.reqSHm.substr(2, 2)}`
      : '';
  },
  // 종료시간
  GET_REQ_E_HM(state) {
    return state.reqEHm !== ''
      ? `${state.reqEHm.substr(0, 2)}:${state.reqEHm.substr(2, 2)}`
      : '';
  },
  // 시작시간 ~ 종료시간
  GET_REQ_S_E_HM(state) {
    if (state.reqSHm !== '' && state.reqEHm !== '') {
      return `${state.reqSHm.substr(0, 2)}:${state.reqSHm.substr(2, 2)}
      ~ ${state.reqEHm.substr(0, 2)}:${state.reqEHm.substr(2, 2)}`;
    } else {
      return '';
    }
  },

  GET_REASON_FLAG(state) {
    return state.reasonFlag;
  },
  GET_REASON(state) {
    return state.reason;
  },

  // ======================= PLAN =======================
  GET_PLAN_PARAM(state) {
    return state.planParam;
  },
  // ======================= ATTEND =======================
  GET_ATTEND_PARAM(state, getters) {
    const attendParam = state.attendParam;
    return {
      ...attendParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_BEFORE_START_HM(state) {
    if (state.bfShm !== '') {
      return `${state.bfShm.substr(0, 2)}:${state.bfShm.substr(2, 2)}`;
    } else {
      return '';
    }
  },
  GET_BEFORE_END_HM(state) {
    if (state.bfEhm !== '') {
      return `${state.bfEhm.substr(0, 2)}:${state.bfEhm.substr(2, 2)}`;
    } else {
      return '';
    }
  },

  // ======================= REWARD =======================
  GET_REWARD_PARAM(state, getters) {
    const rewardParam = state.rewardParam;
    return {
      ...rewardParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_REWARD_LIST(state) {
    return state.rewardList;
  },
  GET_USE_REWARD_LIST(state) {
    return state.useRewardList;
  },
  GET_REWARD_TOTAL_REST_TIME(state) {
    let restTime = 0;
    state.rewardList.forEach(reward => {
      // console.log(reward);
      restTime += reward.restTime;
    });
    return restTime;
  },
  // 보상휴가 신청 메뉴 데이터
  GET_REWARD_APPL_MENU() {
    return { applCd: '42', gntGubunCd: '10', gubun: 'works' };
  },
  // ======================= SCHEDULE =======================
  GET_SCHEDULE_PARAM(state, getters) {
    const scheduleParam = state.scheduleParam;
    return {
      ...scheduleParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_STD_YMD(state) {
    return state.stdYmd ? dayjs(state.stdYmd).format('YYYY-MM-DD') : '';
  },
  GET_WORK_ORG_NM(state) {
    return state.workOrgNm;
  },
  GET_WORK_ORG_TIME_LIST(state) {
    return state.workOrgTimeList;
  },
  GET_SCHEDULE_TIME_CD(state) {
    return state.scheduleTimeCd;
  },
  GET_SCHEDULE_TIME_NM(state) {
    return state.scheduleTimeNm;
  },
  // ======================= OTWORK =========================
  GET_OTWORK_PARAM(state, getters) {
    const otworkParam = state.otworkParam;
    return {
      ...otworkParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_OTWORK_APPL_GUBUN(state) {
    return state.applGubun;
  },
  GET_HOL_YN(state) {
    return state.holYn;
  },
  GET_REQ_TIME_CD(state) {
    return state.reqTimeCd; // 휴일근무 보상구분
  },
  GET_ALTVAC_APPL_STATUS(state) {
    return state.altvacApplStatus;
  },
  GET_ALTER_YMD(state) {
    return state.alterYmd ? dayjs(state.alterYmd).format('YYYY-MM-DD') : '';
  },
  GET_ALTER_GNT_NM(state) {
    return state.alterGntNm;
  },
  GET_IN_OUT_YN(state) {
    return state.inoutYn;
  },
  GET_WORK_YMD(state) {
    return state.workYmd ? dayjs(state.workYmd).format('YYYY-MM-DD') : '';
  },
  GET_REST_HOUR(state) {
    return state.restHour;
  },

  // ======================= VACATION =======================

  GET_VACATION_PARAM(state, getters) {
    const vacationParam = state.vacationParam;
    return {
      ...vacationParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_ALTER_VACATION(state) {
    return state.alterVacation;
  },
  GET_GNT_GUBUN_CD(state) {
    return state.gntGubunCd;
  },
  GET_GNT_CD(state) {
    return state.gntCd;
  },
  GET_HOL_DAY(state) {
    return state.holDay;
  },
  GET_CLOSE_DAY(state) {
    return state.closeDay;
  },
  GET_REST_CNT(state) {
    return state.restCnt;
  },
  GET_S_YMD(state) {
    return state.sYmd !== '' ? dayjs(state.sYmd).format('YYYY-MM-DD') : '';
  },
  GET_E_YMD(state) {
    return state.eYmd !== '' ? dayjs(state.eYmd).format('YYYY-MM-DD') : '';
  },
  GET_APPL_CD1(state) {
    return state.applCd;
  },
  // 기간
  GET_S_E_YMD(state) {
    const reqUseType = state.gntCd.requestUseType;
    const sYmd = dayjs(state.sYmd).format('YYYY-MM-DD');
    const eYmd = dayjs(state.eYmd).format('YYYY-MM-DD');

    if (
      reqUseType === 'AM' ||
      reqUseType === 'PM' ||
      reqUseType === 'QT1' ||
      reqUseType === 'QT4' ||
      reqUseType === 'H'
    ) {
      return `${sYmd}`;
    } else {
      return `${sYmd} ~ ${eYmd}`;
    }
  },
  GET_DATE_TYPE(state) {
    const reqUseType = state.gntCd.requestUseType;
    if (
      reqUseType === 'AM' ||
      reqUseType === 'PM' ||
      reqUseType === 'QT1' ||
      reqUseType === 'QT4'
    ) {
      return 'OD'; // one day
    } else if (reqUseType === 'H') {
      return 'H'; // hour
    } else {
      return 'D'; // days
    }
  },

  // ======================= CANCEL =========================
  GET_CANCEL_PARAM(state, getters) {
    return {
      searchBfApplSeq: state.searchBfApplSeq,
      reason: state.reason,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },

  GET_VACCINATION_PARAM(state, getters) {
    const vaccinationParam = state.vaccinationParam;
    return {
      ...vaccinationParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_EDUSAPP_PARAM(state, getters) {
    const edusAppParam = state.edusAppParam;
    return {
      ...edusAppParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },

  GET_LEAABS_PARAM(state, getters) {
    const leaAbsParam = state.leaAbsParam;
    return {
      ...leaAbsParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_HOL_REPLACE_PARAM(state, getters) {
    const holReplaceParam = state.holReplaceParam;
    return {
      ...holReplaceParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_HOL_REPLACE_CANCEL_PARAM(state, getters) {
    const holReplaceCancelParam = state.holReplaceCancelParam;
    return {
      ...holReplaceCancelParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_RECERT_PARAM(state, getters) {
    const reCertParam = state.reCertParam;
    return {
      ...reCertParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_WORK_SCHEDULE_TIME_PARAM(state, getters) {
    const workScheduleTimeParam = state.workScheduleTimeParam;
    return {
      ...workScheduleTimeParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_VACATIONS_PARAM(state, getters) {
    const vacationsParam = state.vacationsParam;
    return {
      ...vacationsParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
};
